import { AppState, EngagementPhase } from "../store/definitions";
import {
  innerContainerStyles,
  outerContainerStyles,
} from "./styles/RootContainer.styles";

import { Box } from "@twilio-paste/core/box";
import { EntryPoint } from "./EntryPoint";
import { ErrorPhase } from "./ErrorPhase";
import { LoadingPhase } from "./LoadingPhase";
import { MessagingCanvasPhase } from "./MessagingCanvasPhase";
import { PreEngagementFormPhase } from "./PreEngagementFormPhase";
import { useSelector } from "react-redux";

const getPhaseComponent = (phase: EngagementPhase) => {
  switch (phase) {
    case EngagementPhase.Loading:
      return <LoadingPhase />;
    case EngagementPhase.MessagingCanvas:
      return <MessagingCanvasPhase />;
    case EngagementPhase.Error:
      return <ErrorPhase />;
    case EngagementPhase.PreEngagementForm:
    default:
      return <PreEngagementFormPhase />;
  }
};

export function RootContainer() {
  const { currentPhase, expanded } = useSelector(({ session }: AppState) => ({
    currentPhase: session.currentPhase,
    expanded: session.expanded,
  }));

  return (
    <Box>
      <Box {...outerContainerStyles}>
        {expanded && (
          <Box data-test="root-container" {...innerContainerStyles}>
            {getPhaseComponent(currentPhase)}
          </Box>
        )}
        <EntryPoint />
      </Box>
    </Box>
  );
}
